import StarterButton from './StarterButton';
export default StarterButton;
